import React, {Component} from 'react'
import '../../scss/SetupView.scss';
import 'font-awesome/css/font-awesome.min.css';
import {getLocalStorageInfoMonitor,setLocalStorageInfoMonitor,removeShowSetupForce} from '../../tools/LocalStorageHandler'
import {getLocalIpAddress} from '../../tools/LocalIp';


class SetupView extends Component {
  constructor(props) {
    super(props);
    let localStorage = getLocalStorageInfoMonitor()
    this.state = {
      ip: (localStorage.ip !== undefined ? localStorage.ip : ''),
      token: (localStorage.token !== undefined ? localStorage.token : ''),
      localIp : ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    getLocalIpAddress().then(localIpAddress => {
      let newstate = {localIp: localIpAddress};
      if(this.state.ip.length < 1){
        newstate = {ip: localIpAddress, ...newstate};
      }
      this.setState(newstate);
    }).catch(error => {
      this.setState({localIp:error.message})
    });
  }

  handleChange (evt) {
    // check it out: we get the evt.target.name
    // and use it to target the key on our `state` object with the same name, using bracket syntax
    this.setState({ [evt.target.name]: evt.target.value });
  }

  handleClick() {
    if(this.state.ip && this.state.token){
      setLocalStorageInfoMonitor(this.state.ip, this.state.token);
      removeShowSetupForce();
      window.location.reload();
    }
  }


  render() {
    return (
      <div className="SetupView">
        <div>Local IP: {this.state.localIp}</div>
        {(this.props.error !== undefined ? <div>Error: {this.props.error}</div>: '')}
        <input className="inputField" name="ip" type="text" onChange={ this.handleChange } value={this.state.ip} placeholder="Ip"/>
        <input className="inputField" name="token" type="text" onChange={ this.handleChange } value={this.state.token} placeholder="Token"/>

        <input
          className="btn"
          type="button"
          value="Speichern & reload"
          onClick={this.handleClick}
        />
      </div>
    )
  }
}

export default (SetupView);



// WEBPACK FOOTER //
// ./src/components/SetupView/index.js